module.exports = __webpack_public_path__ + "img/珠宝-绿松石标签.8ffaec05.jpg";